// Animations used on all pages
var animations = {
    hasInit: false,
    shScene: null,
    cntScene: null,

    initMapBanner: function() {
        var _this = this;

        if ( $('.map-cta-banner').length < 1 ) { return; }

        var banners = $('.map-cta-banner');

        banners.each(function(i, item) {
            var banner = $(item);
            var id = 'map-cta-banner-'+i;
            banner.attr('id',id);

            var heading = banner.find('.banner-heading'),
                copy = banner.find('.banner-copy'),
                btn = banner.find('.banner-btn'),
                markers = banner.find('.icon-wrapper'),
                shadow = banner.find('.marker-shadow'),
                shadow_outer = banner.find('.marker-shadow .outer'),
                active_pin = banner.find('#marker-one .pin'),
                popup = banner.find('.marker-popup-content');

            var tl = new TimelineMax()
                // copy
                .to( heading, .4, {autoAlpha: '1',x:0} )
                .to( copy, .4, {autoAlpha: '1',x:0}, '-=0.2' )
                .to( btn, .4, {autoAlpha: '1',x:0}, '-=0.2')
                // markers
                .staggerTo(markers, .3, {autoAlpha: '1',y:0}, .2 )
                .to(shadow, .2, {autoAlpha: '1'}, '-=0.2' )
                // active pin: blue, bigger + animate outer shadow
                .to(active_pin, .3, {scale: '1.3', color:'#0065bd'},'+=0.2' )
                .to(shadow_outer, .3, {autoAlpha: '1', scale: '1'},'-=0.3')
                // show popup
                .to(popup, .3, {autoAlpha: '1',y:0} )

                // == shadow pulse
                // fades out
                .to(shadow_outer, .6, {autoAlpha: '0'},'-=0.3')
                .to(shadow_outer, 0, {scale: '0'})
                // fades in
                .to(shadow_outer, .6, {autoAlpha: '1', scale: '1'})
                // fades out
                .to(shadow_outer, .6, {autoAlpha: '0'})
                .to(shadow_outer, 0, {scale: '0'})
                // fades in
                .to(shadow_outer, .6, {autoAlpha: '1', scale: '1'})

            var scene = new ScrollMagic.Scene({
                triggerElement: '#'+id,
                reverse: false
            })
            .setTween(tl)
            .addTo(_this.controller);

            // scene.on("enter", function (event) { });
        })
    },

    staggerResearchStats: function(el) {
        var _this = this;

        if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { return; };

        if ( $(el).length < 1 ) return;

        $(el).each(function(i, el) {
            var els = $(el).find('.stat-item');
            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 'onEnter',
                // duration: '1',
                reverse: false,
                offset: '100'
                // offset: '80'
            })
            .addTo(_this.controller);

            var tween = TweenMax.staggerTo(els, .5, {autoAlpha: '1', y:'0', onComplete: function(){
                _this.controller.removeScene(scene);
            } }, .2);

            scene.setTween(tween);
        });
    },

    // Animate arrow (bounce) one at the time
    animateChartArrow: function(el) {
        var _this = this;

        if ( $(el).length < 1 ) return;

        var allEls = $(el).toArray();

        $(el).each(function(i, el) {
            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 'onEnter',
                reverse: true,
                offset: '50'
            })
           .on('start', function (e) {
                if ( e.scrollDirection == 'REVERSE') {
                    var $arrow = $(allEls[i-1]);
                }
                else {
                    var $arrow = $(el);
                }
                $('.next-chart').removeClass('bounce');
                $arrow.addClass('bounce');
            })
            .addTo(_this.controller);
        });
    },

    // fade in and up 
    fadeInEl: function(el) {
        var _this = this;

        if ( $(el).length < 1 ) return;

        $(el).each(function(i, el) {

            if ( $(el).hasClass('no-animation') || $(el).parents('.vc_row').hasClass('no-animation') ) { 
                return; 
            }

            var scene = new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 'onEnter',
                // duration: '1',
                reverse: false,
                offset: '80'
            })
            .addTo(_this.controller);

            scene.setTween(el, .5, {autoAlpha: '1', y:'0', onComplete: function(){
                _this.removeScene(scene);
            } });
        });
    },

    // el must be slider class
    playSliderOnScroll: function(el) {
        var _this = this;

        if ( $(el).length < 1 ) return;

        // Desktop: play on scroll
        if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {

            $(el).each(function(i, el) {
               var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: 'onCenter',
                    reverse: false,
                    offset: '0'
                })
               .on('start', function () {

                     if ( $(el).hasClass('slick-initialized') ) {
                        $(el).slick('play');
                        $(el).slick('setOption', 'autoplay', true);
                        // $(el).slick('setOption', 'pauseOnHover', true);

                    }
                })
                .addTo(_this.controller);
            })

        } 
    },

    animateRows: function(row) {
        var _this = this;

        if ( $(row).length < 1 ) return;

        $(row).each(function(i, row) {
            
            // Fade in column one after the other
            if ( $(row).hasClass('stagger-animation') ) {
                _this.staggerRowCols($(row));
            } 

            // Parallax sign up form
            else if ( $(row).hasClass('lead-gen-form-row') ) {
                // only on dekstop
                if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { return; };
                
                var firstInit = false;
                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: 'onEnter',
                    duration: '100%', // window height
                    reverse: true,
                    offset: '0'
                })
                .on('start', function () {
                    if ( !firstInit ) {
                        $(row).find('.liquid-main-wrapper').css('opacity','1');
                    }
                    firstInit = true;
                })
                .addTo(_this.controller);

                var left = $(row).find('.col-flex.left');
                var right = $(row).find('.col-flex.right');

                var timeline = new TimelineMax();

                if ( Modernizr.mq("screen and (max-width:"+bp_desktop+"px)")) { 
                    var leftY = '-30';
                    var rightY = '30';
                } else {
                    var leftY = '-60';
                    var rightY = '60';
                }

                timeline.to(left, .5, {y:leftY})
                        .to(right, .5, {y:rightY});

                scene.setTween(timeline);
            }

            // Fade in and up
            // else if (RowFadeInOn && !$(row).hasClass('no-animation')){
            //     // var el = '#'+rowId+' .liquid-main-wrapper';
            //     var el = $(row).find('.liquid-main-wrapper')
            //     var scene = new ScrollMagic.Scene({
            //         triggerElement: this,
            //         triggerHook: 'onEnter',
            //         // duration: '1',
            //         reverse: false,
            //         offset: '80'
            //     })
            //     .addTo(_this.controller);

            //     scene.setTween(el, .5, {autoAlpha: '1', y:'0', onComplete: function(){
            //         _this.removeScene(scene);
            //     } });
            // }
        });
    },

    // el is vc_row.
    staggerRowCols: function($row) {
        var _this = this;
        if ( $row.length < 1 ) return;

        if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { return; };

        // var id = $row.index() + 1;
        // var rowId = 'vc-row-'+id;
        // var rowId = $row.attr('id');
        // if ( rowId == '') {
        //     var id = $(row).index() + 1;
        //     rowId = 'vc-row-'+id;
        //     $(row).attr('id',rowId);
        // }


        $row.each(function(i, el) {
            var els = $row.find('.vc_column_container');
            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 'onEnter',
                // duration: '1',
                reverse: false,
                offset: '200'
                // offset: '80'
            })
            .addTo(_this.controller);

            var tween = TweenMax.staggerTo(els, .5, {autoAlpha: '1', y:'0', onComplete: function(){
                _this.controller.removeScene(scene);
            } }, .2);

            scene.setTween(tween);

            // scene.setTween(el, .5, {autoAlpha: '1', y:'0', onComplete: function(){
            //     _this.controller.removeScene(scene);
            // } });
        });
    },

    destroyMapBanner: function() {
    },

    removeScene: function(scene) {
        var _this = this;
        _this.controller.removeScene(scene);
    },
    
    addCommas: function(nStr) {
        nStr += '';
        x = nStr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    },

    init: function() {
        var _this = this;

        // if ( _this.hasInit ) {return;}

        // init controller
        _this.controller = new ScrollMagic.Controller();

        // Map CTA Banner
        _this.initMapBanner();

        _this.fadeInEl('.scroll-fadeInTop');

        _this.animateRows('.vc_row');


        // Stagger stats on Research page
        _this.staggerResearchStats('.research-market-stats');
        _this.animateChartArrow('.next-chart');

        // _this.playSliderOnScroll($('.logo-slider .slider'));

        // on Desktop only (mobile no autoplay)
        if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
            _this.fadeInEl('.footer-signup-section');
        } 
        // on tablet and under
        else {
        }

        if($(".stats-counter .counter").length) {
            var countSpeed = 2000;
            // var countOffset = 
            _this.cntScene = new ScrollMagic.Scene({
                triggerElement: '.circles',
                triggerHook: 'onEnter',
                // duration: '1',
                reverse: false,
                offset: '80'
                // offset: '-80' // 80px above
            })
            .on('start', function () {
                $('.stats-counter .counter').each(function() {
                    var $this = $(this),
                        countTo = $this.attr('data-count');

                    $({ countNum: $this.text()}).animate({
                      countNum: countTo
                    },

                    {
                        duration: countSpeed,
                        easing:'linear',
                        step: function() {
                          var orNum = Math.floor(this.countNum);
                          var cNum = _this.addCommas(orNum);
                          $this.text(cNum);
                        },
                        complete: function() {
                          $this.text(_this.addCommas(this.countNum));
                        }
                    });  
                });
            })
            .on('end', function () {
                _this.removeScene(_this.cntScene);
            })
            .addTo(_this.controller);
        }

        // === SoHubs
        if ( $(".sohubs-section").length ) {
            _this.shScene = new ScrollMagic.Scene({
                triggerElement: '.sohubs-section',
                triggerHook: 'onEnter',
                // duration: '1',
                reverse: false,
                // offset: '80'
                offset: '-80' // 80px above sohubs
            })
            .on('start', function () {
                // load sohubs
                sohubs.init();
            })
            .on('end', function () {
                _this.removeScene(_this.shScene);
            })
            .addTo(_this.controller);

            // // fade in and up
            // shScene.setTween('.sohubs-section', .5, {autoAlpha: '1', y:'0', onComplete: function(){
            //     _this.removeScene(shScene);
            // } });
        }



        // === Gallery
        if ( $('.gallery-container').length ) {
            $('.gallery-container').each(function(i, el) {

                var galleryScene = new ScrollMagic.Scene({
                    triggerElement: el,
                    triggerHook: 'onEnter',
                    // duration: '1',
                    reverse: false,
                    // offset: '80'
                    offset: '-80' // 80px before
                })
                .on('start', function () {
                    // init gallery
                    initGallery($(el));
                })
                .on('end', function () {
                    _this.removeScene(galleryScene);
                })
                .addTo(_this.controller);

            });
        }

        // === Featured Projects
        if ( $('.featured-projects-section').length ) {
            $('.featured-projects-section').each(function(i, el) {

                var featuredProjectsScene = new ScrollMagic.Scene({
                    triggerElement: el,
                    triggerHook: 'onEnter',
                    // duration: '1',
                    reverse: false,
                    offset: '80'
                })
                .on('start', function () {
                    // manually load images
                    $(el).find('.bg-img').each(function(){
                        var url = $(this).attr('data-lazy');
                        $(this).css('background-image','url("'+url+'")');
                    })
                })
                .addTo(_this.controller);
                
                // fade in slider
                featuredProjectsScene.setTween(el, .5, {autoAlpha: '1', y:'0', onComplete: function(){
                    _this.removeScene(featuredProjectsScene);
                } });

            });
        }

        // === Testimonials
        if ( $('.testimonial-section').length ) {
            $('.testimonial-section').each(function(i, el) {

                var testiScene = new ScrollMagic.Scene({
                    triggerElement: el,
                    triggerHook: 'onEnter',
                    // duration: '1',
                    reverse: false,
                    offset: '80'
                })
                .on('start', function () {
                    // manually load images
                    $(el).find('.img-block').each(function(){
                        var url = $(this).attr('data-lazy');
                        $(this).css('background-image','url("'+url+'")');
                    })
                })
                .addTo(_this.controller);
                
                // fade in slider
                testiScene.setTween(el, .5, {autoAlpha: '1', y:'0', onComplete: function(){
                    _this.removeScene(testiScene);
                } });

            });
        }

        // === Content Sliders
        if ( $('.content-slider-container').length ) {
            $('.content-slider-container').each(function(i, el) {

                var contentSliderScene = new ScrollMagic.Scene({
                    triggerElement: el,
                    triggerHook: 'onEnter',
                    // duration: '1',
                    reverse: false,
                    offset: '-80' // 80px before
                })
                .on('start', function () {
                    // manually load images
                    var imgs = $(el).find('.lazy-slide-bg');
                    imgs.each(function(){
                        $image = $(this);
                        // Mobile: Accordion
                        if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
                            $image.attr("data-original",  $image.attr('data-mobileImage'));
                        } 
                        // Desktop: Slider
                        else {
                            $image.attr("data-original",  $image.attr('data-fullImage'));
                        }

                        var url = $image.attr('data-original');

                        // http://mikefowler.me/journal/2014/04/22/cached-images-load-event
                        // https://stackoverflow.com/questions/5057990/how-can-i-check-if-a-background-image-is-loaded

                        var $img = $('<img />').appendTo($image);

                        $img.attr('src', url);

                        $img.on('load', function() {
                            var $image = $img.parent('.lazy-slide-bg');
                            $image.css('background-image', 'url("'+url+'")');
                            $image.removeClass('loading');
                            $(this).remove(); // prevent memory leaks as @benweet suggested
                        });

                        if ($img[0].complete) {
                          $img.load();
                        }

                    })

                })
                .addTo(_this.controller);
                
                // fade in slider
                // contentSliderScene.setTween(el, .5, {autoAlpha: '1', y:'0', onComplete: function(){
                //     _this.removeScene(contentSliderScene);
                // } });

            });
        }



        // _this.hasInit = true; 

        $(window).smartresize(function(){
            if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
                _this.fadeInEl('.footer-signup-section');
            } 
        })

    },
    destroy: function() {
        var _this = this;
        // _this.hasInit = false;
        // sohubs.destroy();
        if ( _this.shScene ) {
            _this.shScene.destroy();
        }
        
        if ( _this.cntScene ) {
            _this.cntScene.destroy();
        }
    }
}


// Animations on page load.
var pageAnimation = {
    homeHasAnimated: false,
    animateHome: function() {
        var _this = this;

        // play only once (1st time user go on homepage)
        if ( _this.homeHasAnimated ) { return; }

        var timeline = new TimelineMax();

        var speed = .4;
        var staggerDelay = '-=.1';

        var container = $('#videoContainer').length > 0 ? $('#videoContainer') : $('#bannerContainer');

        // Mobile Animation
        if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
            timeline
                // banner copy
                .to($('.home-hero-banner .statement-slider'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, '+=.5')
                .to($('#banner_video_btn'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, staggerDelay)
                .to($('.home-hero-banner .subtitle'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, staggerDelay)
                // video
                .to(container, .6, {top:'0', ease: transition_easing}, '+=.4')
                // header
                .to($('#header .logo-link'), speed, {autoAlpha: '1', x:'0', ease: transition_easing})
                .to($('#header .trigger-mobile-menu'), speed, {autoAlpha: '1', ease: transition_easing}, staggerDelay)
                .to($('#header .btn-list'), speed, {autoAlpha: '1', ease: transition_easing})
                // scroll down
                .to($('.home-hero-banner .bottom-text h5'), speed, {autoAlpha: '1', y:'0', ease: transition_easing})
                .to($('.home-hero-banner .bottom-text .line'), speed, {autoAlpha: '1', y:'0',scale:'1', ease: transition_easing, onComplete: handleComplete}, staggerDelay);

        }
        // Desktop Animation
        else {
            timeline
                // banner copy
                .to($('.home-hero-banner .statement-slider'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, '+=.5')
                .to($('#banner_video_btn'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, staggerDelay)
                .to($('.home-hero-banner .subtitle'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, staggerDelay)
                // video
                .to(container, .6, {top:'0', ease: transition_easing}, '+=.4')
                // .to($('#background_video'), .6, {scale: '1', ease: transition_easing}, '-=.6')
                // header
                .to($('#header .logo-link'), speed, {autoAlpha: '1', x:'0', ease: transition_easing})
                .to($('#header .nav-menu'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, staggerDelay)
                .to($('#header .secondary-menu > ul'), speed, {autoAlpha: '1', x:'0', ease: transition_easing}, staggerDelay)
                .to($('#header .btn-list'), speed, {autoAlpha: '1', x:'0', ease: transition_easing})
                // scroll down
                .to($('.home-hero-banner .bottom-text h5'), speed, {autoAlpha: '1', y:'0', ease: transition_easing})
                .to($('.home-hero-banner .bottom-text .line'), speed, {autoAlpha: '1', y:'0',scale:'1', ease: transition_easing, onComplete: handleComplete}, staggerDelay);

        }

        

        function handleComplete() {
            // remove overflow hidden: allow scroll
            $('body').css('overflow','');
            $('body').removeClass('screen-preloader-on');

            // start setTimeout for site popup display
            forms.displaySitePopup();
            
            // $('body').css('overflow','initial');

            // play banner statement slider
            if ( $('.home-hero-banner .statement-slider').hasClass('slick-initialized') ) {
                $('.home-hero-banner .statement-slider').slick('play');
                $('.home-hero-banner .statement-slider').slick('setOption', 'autoplay', true); // to set pause on hover option
            }
            $('body').removeClass('home-will-animate');
            _this.homeHasAnimated = true;
        }
    },
    animateAll: function() {
        var _this = this;
        // do not animate on tablet and under 
        if ( Modernizr.mq("screen and (max-width:" + bp_tablet_landscape + ")") ) { return; }

        // Home page 
        if ( $('#main').attr('data-page-key') === ('home') ) {

            _this.animateHome();
        }
    },
    init: function() {
        var _this = this;
        _this.animateAll();

        $(window).smartresize(function(){ 
            // _this.animateAll();
        });
    }
}